import React, { useEffect, useState } from 'react';
import useRouter from '../hook/useRouter';
export interface IRangeSliderProp {
    min: number;
    max: number;
    step: number;
    watch1: string;
    watch2: string;
    ga360str: string;
    l10n: { [key: string]: string };
    submitCallback: (_val: { min: number; max: number }) => void;
}

export const RangeSlider = ({ props }: { props: IRangeSliderProp }) => {
    const { min, max, step, submitCallback, watch1, watch2, ga360str, l10n } = props;
    const { params, getValue, changeParam } = useRouter([watch1, watch2]);
    const [minValue, setMinValue] = useState(min);
    const [maxValue, setMaxValue] = useState(max);

    const [value, setValue] = useState({ min: min, max: max });

    useEffect(() => {
        if (!params) return;
        const minParam = getValue(watch1) || min.toString();
        const maxParam = getValue(watch2) || max.toString();

        setMinValue(parseInt(minParam));
        setMaxValue(parseInt(maxParam));
    }, [params]);

    React.useEffect(() => {
        if (value) {
            setMinValue(value.min);
            setMaxValue(value.max);
        }
    }, [value]);

    const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const newMinVal = Math.min(+e.target.value, maxValue);
        setValue({ min: newMinVal, max: maxValue });
    };

    const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const newMaxVal = Math.max(+e.target.value, minValue);
        setValue({ min: minValue, max: newMaxVal });
    };

    const onNumberClick = (e: React.MouseEvent<HTMLSpanElement>) => {
        const selNum = e.currentTarget.dataset.idx || '0';
        const selectNum = parseInt(selNum);
        if (selectNum < minValue) {
            updataValue(selectNum, maxValue);
            return;
        }
        if (selectNum > maxValue) {
            updataValue(minValue, selectNum);
            return;
        }
        if (minValue < selectNum && selectNum < maxValue) {
            const minabs = selectNum - minValue;
            const maxabs = maxValue - selectNum;
            if (minabs > maxabs) {
                updataValue(minValue, selectNum);
            } else if (maxabs > minabs) {
                updataValue(selectNum, maxValue);
            } else if (minabs === maxabs) {
                updataValue(minValue, selectNum);
            }
            return;
        }
    };

    const [minStyle, minStyleSet] = useState({
        zIndex: 10,
    });

    const [maxStyle, maxStyleSet] = useState({
        zIndex: 20,
    });

    const updataValue = (_min: number, _max: number) => {
        submitCallback({ min: _min, max: _max });
        changeParam({ [watch1]: _min.toString(), [watch2]: _max.toString(), page: '' });

        if (_min === max && _max === max) {
            minStyleSet({ zIndex: 20 });
            maxStyleSet({ zIndex: 10 });
            console.log('1', minStyle, maxStyle);
        }

        if (_min === min && _max === min) {
            minStyleSet({ zIndex: 10 });
            maxStyleSet({ zIndex: 20 });
            console.log('2', minStyle, maxStyle);
        }
    };

    const minPos = ((minValue - min) / (max - min)) * 100;
    const maxPos = ((maxValue - min) / (max - min)) * 100;
    const mylength = Math.ceil((max - min + 1) / step);

    return (
        <section className="enchant">
            <header>{l10n['noti.enchantstage']}</header>
            <article>
                <div className="wrapper">
                    <div className="input-wrapper">
                        <input
                            className="input"
                            type="range"
                            value={minValue}
                            min={min}
                            max={max}
                            step={step}
                            onChange={handleMinChange}
                            onMouseUp={() => updataValue(value.min, value.max)}
                            onTouchEnd={() => updataValue(value.min, value.max)}
                            style={minStyle}
                        />
                        <input
                            className="input"
                            type="range"
                            value={maxValue}
                            min={min}
                            max={max}
                            step={step}
                            onChange={handleMaxChange}
                            onMouseUp={() => updataValue(value.min, value.max)}
                            onTouchEnd={() => updataValue(value.min, value.max)}
                            style={maxStyle}
                        />
                    </div>

                    <div className="control-wrapper">
                        <div className="control" style={{ left: `${minPos}%` }} />
                        <div className="rail">
                            <div className="inner-rail" style={{ left: `${minPos}%`, right: `${100 - maxPos}%` }} />
                        </div>
                        <div className="control" style={{ left: `${maxPos}%` }} />
                        <div className="control-numbers" data-areas={ga360str}>
                            {Array.from({ length: mylength }).map((_, i) => (
                                <span
                                    data-idx={i}
                                    data-areas={ga360str}
                                    data-contents={i}
                                    onClick={onNumberClick}
                                    className="number"
                                    key={'range' + i}
                                >
                                    <ins>{i}</ins>
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </article>
        </section>
    );
};
// 시세_조건검색_강화단계_클릭
